import { FormControl, Tooltip, Select, MenuItem, Checkbox, ListItemText, Button, TextField } from '@mui/material'

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import BaseURL from "../../../../utils/base-uri.json";
import React, { useState, useEffect, useRef } from 'react';

import useFetch from "../../../../utils/useFetch";
import { getGlobalClientId, getToken } from "../../../../utils/Token";
import { getOrgId } from '../../../../utils/Token';
import { getOrgType } from '../../../../utils/Token';

export default function ReportExpiringDocument({ close, name }) {
  const [documentTypes, setDocumentTypes] = React.useState([]);
  documentTypes?.sort((a, b) => a.value.localeCompare(b.value));
  const [token, setToken] = useState(getToken())

  const { data: res } = useFetch(
    "Documents/GetDocumentTypes");
  useEffect(() => {
    if (res?.data) {
      setDocumentTypes(res?.data)
    }
  }, [res]);

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 224,
        width: 120,

      },
    },
  };

  const [selectedDocs, setSelectedDocs] = useState([]);

  const handleDocTypeChange = (event) => {
    setSelectedDocs(event.target.value);
  };

  const menuListRef = useRef(null);
  const handleMenuOpen = () => {
    scrollToTopOfOtions();
  };
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <form action={BaseURL?.baseReportUrl + "ExpiringDocumentWebForm.aspx"} method="post" target="_blank">
          <div style={{ marginLeft: "25px" }}>
            <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>Documents</span>
            <br />
            <FormControl>
              <Select
                      onOpen={handleMenuOpen}
                labelId="docs-label"
                id="docs-select"
                multiple
                size='small'
                sx={{ width: "340px", overflow: "hidden" }}
                name="doctypeList"
                value={selectedDocs}
                onChange={handleDocTypeChange}
                MenuProps={{
                  ref: menuListRef,
                  PaperProps: MenuProps.PaperProps,
                }
                }
                renderValue={(selected) =>
                  selected
                    .map((value) => documentTypes?.find((doc) => doc?.key === value)?.value)
                    .filter((value) => value !== undefined)
                    .join(", ")
                }
                inputProps={{ 'aria-label': 'Select Documents' }}
              >
                <MenuItem key="Select All">
               
                  <Checkbox
                    id="select-all-checkbox"
                    indeterminate={
                      selectedDocs?.length > 0 && selectedDocs?.length < documentTypes?.length
                    }
                    checked={selectedDocs?.length === documentTypes?.length}
                    onChange={(event) => {
                      if (event?.target?.checked) {
                        setSelectedDocs(documentTypes?.map((doc) => doc?.key));
                        scrollToTopOfOtions();
                      } else {
                        setSelectedDocs([]);
                      }
                    }}
                  />
                     <label htmlFor="select-all-checkbox" style={{fontSize:"16px",fontWeight:"500",color:"rgba(0, 0, 0, 0.87)",width:"320px",cursor:"pointer"}}>
                    Select All
                  </label>
                </MenuItem>
                {documentTypes?.map((doc) => (
                  <MenuItem key={doc?.key} value={doc?.key} title={doc?.value}>
                    <Checkbox checked={selectedDocs?.indexOf(doc?.key) > -1} />
                    <ListItemText primary={doc?.value} sx={{ overflowX: "hidden" }} />
                  </MenuItem>
                ))}
              </Select>

            </FormControl>



            <TextField hidden={true} name="clientId" value={getOrgId()} />
            <TextField hidden={true} name="roleName" value={getOrgType()}/>

            <br />
          </div>

          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button variant="contained" className="login-help-button-cancel" onClick={close}> Cancel</Button>
              {selectedDocs == "" ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={selectedDocs == ""}
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>

          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>

        <br />

      </DialogContent>

    </>
  )
}
